import { AppBar, UserMenu, Logout } from "react-admin";
import { Box, Select, MenuItem, Typography, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { BRANDS } from "../config/brands";

const useStyles = makeStyles((theme) => ({
  title: {
    flexShrink: 0,
    marginRight: theme.spacing(2),
    whiteSpace: "nowrap",
  },
  brandSelect: {
    color: "#fff",
    flex: "1 1 auto",
    minWidth: 0,
    maxWidth: 220,
    "& .MuiSelect-select": {
      color: "#fff",
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(255, 255, 255, 0.4)",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(255, 255, 255, 0.8)",
    },
    "& .MuiSvgIcon-root": {
      color: "#fff",
    },
  },
}));

const BrandAppBar = ({ brandKey, brandName, onBrandChange, ...props }) => {
  const classes = useStyles();
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <AppBar {...props} userMenu={false}>
      <Box display="flex" alignItems="center" flex={1} minWidth={0} pl={1}>
        {!isSmall && (
          <Typography variant="h6" className={classes.title}>
            Panel Administrativo
          </Typography>
        )}
        <Select
          value={brandKey}
          onChange={(e) => onBrandChange(e.target.value)}
          variant="outlined"
          size="small"
          className={classes.brandSelect}
        >
          {Object.entries(BRANDS).map(([key, cfg]) => (
            <MenuItem key={key} value={key}>
              {cfg.name}
            </MenuItem>
          ))}
        </Select>
      </Box>
      <UserMenu>
        <Logout />
      </UserMenu>
    </AppBar>
  );
};

export default BrandAppBar;